import(/* webpackMode: "eager", webpackExports: ["PublicCatalogDataProvider"] */ "/app/src/components/PublicCatalogData.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/services/tours/index.jsx");
